import { useAssetPairPrice } from 'modules/blockChain/hooks/useAssetPairPrice'

import { InfoFieldValue } from 'shared/ui/common/InfoFieldValue'

import { weiToNum } from 'modules/blockChain/utils/parseWei'
import { formatAsset } from 'modules/pools/utils/formatAsset'
import { PoolAsset } from 'modules/pools/constants/poolAssets'

type Props = {
  asset: PoolAsset
  amount: number
}

export function TransactionRowAmount({ asset, amount }: Props) {
  const assetPriceData = useAssetPairPrice(asset, 'USD')

  const amountUSD =
    assetPriceData &&
    weiToNum(assetPriceData.price, assetPriceData.decimals) * amount

  return (
    <InfoFieldValue
      value={formatAsset(amount, asset)}
      sign={asset}
      tooltip={amount}
      secondaryValue={
        amountUSD ? <>({formatAsset(amountUSD, 'USD')} USD)</> : 'Loading...'
      }
      secondaryValueSize={16}
      secondaryValueTooltip={amountUSD}
    />
  )
}
